import { useState, useRef, useCallback } from 'react';
import { useAuth } from '../contexts/AuthContext';

export function useAiNormalize() {
  const { authAxios } = useAuth();
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const abortRef = useRef(null);

  const normalize = useCallback(async (title, content, source = 'manual', metadata = null) => {
    if (!title || title.trim().length < 3) {
      setResult(null);
      return null;
    }

    setLoading(true);
    setError(null);

    try {
      const api = authAxios();
      const res = await api.post('/ai/normalize', {
        title: title.trim(),
        content: content || '',
        source,
        metadata,
      });
      const data = res.data;
      if (data.success) {
        setResult(data);
      } else {
        setError(data.error || 'Normalisatie mislukt');
        setResult(null);
      }
      return data;
    } catch (e) {
      const msg = e.response?.data?.detail || 'AI normalisatie mislukt';
      setError(msg);
      setResult(null);
      return null;
    } finally {
      setLoading(false);
    }
  }, [authAxios]);

  const reset = useCallback(() => {
    setResult(null);
    setLoading(false);
    setError(null);
  }, []);

  return { result, loading, error, normalize, reset };
}
